<template>
  <div>
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/rupc_bg_006.png);"
      ></div>
      <div class="container">
        <h1>ABOUT <span>US</span></h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
        </ul>
      </div>
    </div>
    <section>
      <div class="block cmi-about">
        <div class="container">
          <div class="row">
            <div class="col-md-6 column">
              <div class="simple-text">
                <h3>WHAT WE BELIEVE</h3>
                <p>
                  The Bible is the inspired Word of God. 2 Tim. 3:16, 2 Pet.
                  1:19-21 That God is One. That in Jesus Christ, God was
                  manifest in the flesh; and that in Jesus dwells all the
                  fullness of the Godhead bodily. Ex. 20:1-5, Is. 45:5, Mt.
                  1:21-23, Col. 2:9
                </p>
                <p>
                  We receive salvation by grace through faith in the Lord Jesus
                  Christ. We are partakers of this salvation through obeying the
                  Truth of the Gospel in repentance from sin, baptism in the
                  name of Jesus Christ for the remission of sin, and by
                  receiving the Holy Ghost with the evidence of speaking in
                  other tongues as the spirit gives utterance. We are baptized
                  by this one spirit into the body of Christ.Eph. 2:8, Rom.
                  5:1;6:1-6, Acts 2:38, 1 Cor. 12:13
                </p>
                <p>
                  In the personal and imminent return of our Lord Jesus Christ
                  for the Church, and His personal return with His saints in the
                  Second Advent. Phil. 3:20-21, Rev. 22:20
                </p>
              </div>
            </div>
            <div class="col-md-6 column">
              <div
                class="simple-text wow fadeInRight"
                data-wow-duration="2s"
                data-wow-delay="0.5s"
              >
                <h3>WHAT WE BELIEVE</h3>
                <p>
                  In Divine healing. James 5:14, 1 Pet. 2:24, Is.53:5
                </p>
                <p>
                  That all men are lost outside the scope of the redemptive work
                  of Christ. Eph. 2:12, Gal. 5:6;2:15-16, Rom. 3:23-26;6:23, Mk
                  16:16 In observing the Lord’s supper as a memorial of His
                  broken body and the New Testament in His Blood. 1 Cor.
                  11:23-26
                </p>
                <p>
                  All believers must live a holy life. Heb. 12:14, 1 Pet.
                  1:13-16. Titus 2:11-12, 2 Cor. 7:1
                </p>
                <p>
                  In the nine Gifts of the Spirit being in operative in the
                  Church. 1 Cor 12:1-11
                </p>
                <p>
                  In the God-given ministries of the Church. Eph 4:11-13
                </p>
                <p>
                  That every believer is to manifest the fruit of the Spirit in
                  his life. Gal 5:22-23
                </p>
                <p>
                  Tithing is God’s financial plan for providing for His work.
                  Mal 3:10, 1 Cor 4:2, 1 Cor 16:2
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-cov></footer-cov>
  </div>
</template>
<script>
import FooterCov from "./FooterCoventry";

export default {
  components: {
    FooterCov
  },
  data() {
    return {};
  }
};
</script>
